/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1DocumentSendEmail202,
  PostApiV1DocumentSendEmail401,
  PostApiV1DocumentSendEmail404,
  PostApiV1DocumentSendEmail500,
  PostApiV1DocumentSendEmailMutationRequest,
  PostApiV1DocumentSendEmailMutationResponse,
} from "../../types/documentCourseRegistrationController/PostApiV1DocumentSendEmail.ts";
import { sendEmailDocumentViewModelSchema } from "../sendEmailDocumentViewModelSchema.ts";

/**
 * @description (Accepted) Requisição aceita.
 */
export const postApiV1DocumentSendEmail202Schema =
  z.boolean() as unknown as ToZod<PostApiV1DocumentSendEmail202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1DocumentSendEmail401Schema =
  z.any() as unknown as ToZod<PostApiV1DocumentSendEmail401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1DocumentSendEmail404Schema =
  z.any() as unknown as ToZod<PostApiV1DocumentSendEmail404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1DocumentSendEmail500Schema =
  z.any() as unknown as ToZod<PostApiV1DocumentSendEmail500>;

export const postApiV1DocumentSendEmailMutationRequestSchema = z.lazy(
  () => sendEmailDocumentViewModelSchema,
) as unknown as ToZod<PostApiV1DocumentSendEmailMutationRequest>;

export const postApiV1DocumentSendEmailMutationResponseSchema = z.lazy(
  () => postApiV1DocumentSendEmail202Schema,
) as unknown as ToZod<PostApiV1DocumentSendEmailMutationResponse>;
